<template>
  <section class="profile-content">
    <div class="left" :class="{ 'left_full': ctfMode == 'users' }">
      <div class="first">
        <div v-if="ctfMode == 'teams'" class="user-name">
           <span class="img"></span>
           <span class="name" :title="profile.name">{{profile.name}}</span>
        </div>
        <div v-if="ctfMode == 'users'" class="user-logo">
          <form id="logo_upload" action="/api/upload_logo" method="POST" enctype="multipart/form-data" ref="imgForm">
            <div class="logo_box">
              <img id="logo" :src="logoUrl" alt="" />
              <input type="file" name="logo" @change="submit"/>
            </div>
          </form>
        </div>
        <div class="user-info">
            <div v-if="ctfMode == 'users'" class="user-name">
               <span class="name" v-bind:title="profile.nick">{{profile.nick || profile.uid}}</span>
            </div>
            <div class="Email">
              {{userId_}}：<span>{{profile.uid}}</span>
            </div>
            <div v-if="ctfMode == 'users'" class="rank">
              {{rank_}}：<span>{{rank}}/{{total_teams}}</span>
            </div>
            <div class="score">
              {{score_}}：<span>{{score}}</span>
            </div>
           <!--<div class="flag" v-if="isTeam">-->
              <!--{{location_}}: <img :title="flagTitle" :src="flagURL"></img>-->
           <!--</div>-->
           <div class="Email">
              {{email_}}:<a :href="'mailto:' + profile.email">{{profile.email}}</a>
           </div>
        </div>
        <div class="logout-button pull-right">
           <a @click="logout" class="btn btn-large btn-block">{{logout_}}</a>
        </div>
      </div>
      <div class="second">
        <span>{{solvedChallenges_}}</span>
        <ul class="table">
          <li class="thead">
            <a>
              <span>{{name_}}</span>
              <span>{{score_}}</span>
              <span>{{time_}}</span>
            </a>
          </li>
          <li class="tr" v-for="r in result">
            <router-link :to="r.pid && '/challenge/'+r.pid || ''">
              <span>{{r.title}}</span>
              <span>{{r.score}}</span>
              <span>{{formatTime(r.timestamp)}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="ctfMode == 'teams'" class="right">
      <div class="first hasTeam" v-if="isTeam">
        <div class="team-info">
          <img class="team" :src="logoUrl"></img>
          <i> {{teamName}} </i>
          <img class="flag" :title="flagTitle" :src="flagURL"></img>
        </div>
        <div class="team-rate">
          {{rank_}}: <i>{{rank}}/{{total_teams}}</i>
          {{score_}}: <i>{{score}}</i>
        </div>
        <div class="progress">
          <div class="progress-bar" :style="{width: percentage + '%'}"></div>
        </div>
        <div class="team-question">
          {{solved}}<i>{{solved_}}</i><i>/</i>{{challengeCount}}<i>{{total_}}</i>
        </div>
        <div class="team-button">
           <router-link to="/team/_" class="btn btn-large btn-block">{{myTeam_}}</router-link>
        </div>
      </div>
      <div class="first noTeam" v-if="!isTeam">
        <div>{{inputToken_}}</div>
        <div class="token">
          <input type="text" value="" v-model="token" placeholder="Token"/>
          <div>
              <a class="btn btn-large btn-block" @click="join">{{join_}}</a>
          </div>
        </div>
        <div class="create"><span>{{or_}} </span><router-link to="/createTeam">{{createTeam_}}</router-link></div>
      </div>
      <div class="second" v-if="isRank">
        <h5>Top 10</h5>
        <table class="table rank">
          <thead>
            <tr>
              <th>{{rank_}}</th>
              <th>{{team_}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, index) in rankInfo">
              <td>{{index + 1}}</td>
              <td>{{r}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { profile, team, joinTeam, logout, uploadLogo } from '@/utils/api.js'
  import { getCookie } from '@/utils/cookies.js'
  import { natural, formatTime } from '@/utils'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        rankInfo: [],
        result: [],
        token: '',
        solved: 0,
        challengeCount: 0,
        rank: 0,
        total_teams: 0,
        score: 0,
        teamName: '',
        isTeam: false,
        isRank: false,
        flagTitle: '',
        flagURL: '',
        logoUrl: '/logo/player_default.png',
        date: ''
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale', 'ctfMode']),
      ...mapGetters([]),
      ...i18n.map([
        'location_', 'email_', 'logout_', 'solvedChallenges_', 'name_',
        'score_', 'time_', 'rank_', 'userId_', 'solved_', 'total_', 'myTeam_',
        'inputToken_', 'join_', 'or_', 'createTeam_', 'rank_', 'team_'
      ]),
      percentage () {
        const per = this.solved / this.challengeCount * 100
        return per <= 100 ? per : 0
      }
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      formatTime,
      init () {
        const name = getCookie('uid')
        if (name && getCookie('sig')) {
          this.profile.name = name
        } else return this.$router.push('/login')

        profile()
          .then((data) => {
            this.profile.email = data.data.email
            this.profile.rating = data.data.rating
            this.profile.uid = data.data.uid
            this.profile.nick = data.data.nick

            this.challengeCount = data.data.total_problems

            this.result = data.data.solved || []
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })

        team('_')
          .then((data) => {
            if (!data || data.err) {
              return null
            }
            this.isTeam = true
            if (data.country) {
              this.flagURL = `/flags/${data.country.toLowerCase()}.png`
            }
            this.teamName = data.name
            this.logoUrl = data.logo || '/logo/player_default.png'
            this.solved = data.solved.length
            this.score = data.rating
            this.members = data.size || 1
            this.rank = natural(data.rank)
            this.total_teams = natural(data.total_teams)

            return data.tid
          })
          .catch((err) => {
            const [error] = err.message.split(': ')
            if (error === 'not_found') {
              this.isTeam = false
              return
            }
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      submit () {
        const fd = new FormData(this.$refs.imgForm)
        uploadLogo(fd)
          .then((data) => {
            this.logoUrl = data.logo
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      logout,
      join () {
        const token = this.token
        joinTeam(token)
          .then((data) => {
            this.init()
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      }
    },
    created () {
      this.init()
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/profile.vue